import type { Game } from './games';

export const games: Game[] = [
  {
    id: 'g1',
    name: '热血江湖传',
    slug: 'rexue-jianghu',
    category: 'role-playing',
    description: '经典武侠RPG网页游戏，沉浸式江湖冒险体验，万人同屏热血对战，打造属于你的江湖传奇。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20fantasy%20game%20scene%20with%20ancient%20temples%20and%20warriors%20in%20flowing%20robes%20on%20misty%20mountains%2C%20warm%20golden%20lighting%2C%20painterly%20art%20style%2C%20soft%20background%20with%20subtle%20gradients&width=600&height=400&seq=game-rpg-01&orientation=landscape',
    rating: 4.8,
    players: '1280万',
    tags: ['热门', '武侠', '多人在线'],
    featured: true,
  },
  {
    id: 'g2',
    name: '三国群英战',
    slug: 'sanguo-qunying',
    category: 'strategy',
    description: '史诗级三国策略大作，招募名将、排兵布阵、攻城略地，智谋与勇武的终极较量。',
    image: 'https://readdy.ai/api/search-image?query=Three%20Kingdoms%20strategy%20war%20game%20with%20ancient%20Chinese%20generals%20on%20horseback%20leading%20armies%20on%20a%20vast%20battlefield%2C%20dramatic%20sky%2C%20epic%20scale%2C%20warm%20earthy%20tones%2C%20artistic%20illustration%20style&width=600&height=400&seq=game-strategy-01&orientation=landscape',
    rating: 4.7,
    players: '960万',
    tags: ['策略', '三国', '对战'],
    featured: true,
  },
  {
    id: 'g3',
    name: '星际突击队',
    slug: 'xingji-tuji',
    category: 'shooting',
    description: '科幻题材第一人称射击游戏，炫酷武器系统与刺激的多人竞技模式，感受星际战场的震撼。',
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20shooter%20game%20with%20space%20soldiers%20in%20advanced%20armor%20battling%20in%20a%20neon-lit%20space%20station%2C%20dynamic%20action%20pose%2C%20cinematic%20lighting%2C%20digital%20art%20style%2C%20clean%20composition&width=600&height=400&seq=game-shooting-01&orientation=landscape',
    rating: 4.6,
    players: '850万',
    tags: ['科幻', '射击', '竞技'],
    featured: true,
  },
  {
    id: 'g4',
    name: '开心消消乐园',
    slug: 'kaixin-xiaoxiaole',
    category: 'casual',
    description: '超萌治愈系休闲消除游戏，丰富关卡与可爱角色，随时随地轻松解压，全家老少都爱玩。',
    image: 'https://readdy.ai/api/search-image?query=Cute%20colorful%20casual%20puzzle%20game%20with%20adorable%20animal%20characters%20and%20bright%20candy-like%20elements%20in%20a%20magical%20garden%20setting%2C%20soft%20pastel%20colors%2C%20playful%20atmosphere%2C%20illustration%20style&width=600&height=400&seq=game-casual-01&orientation=landscape',
    rating: 4.9,
    players: '2150万',
    tags: ['休闲', '消除', '治愈'],
    featured: true,
  },
  {
    id: 'g5',
    name: '仙剑奇缘录',
    slug: 'xianjian-qiyuan',
    category: 'role-playing',
    description: '仙侠题材MMORPG巨作，精美画面与感人剧情，御剑飞行探索广袤仙侠世界。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20xianxia%20fantasy%20game%20with%20floating%20immortal%20on%20a%20flying%20sword%20above%20clouds%20and%20ancient%20Chinese%20palaces%2C%20ethereal%20atmosphere%2C%20soft%20golden%20and%20jade%20tones%2C%20painterly%20style&width=600&height=400&seq=game-rpg-02&orientation=landscape',
    rating: 4.7,
    players: '720万',
    tags: ['仙侠', '角色扮演', '开放世界'],
    featured: false,
  },
  {
    id: 'g6',
    name: '帝国时代OL',
    slug: 'diguo-shidai',
    category: 'strategy',
    description: '经典即时战略网页版，建造帝国、发展科技、征服世界，重温RTS黄金时代的辉煌。',
    image: 'https://readdy.ai/api/search-image?query=Medieval%20empire%20building%20strategy%20game%20with%20castle%20construction%20and%20armies%20marching%20across%20green%20fields%2C%20isometric%20view%2C%20warm%20sunlight%2C%20detailed%20illustration%2C%20historical%20setting&width=600&height=400&seq=game-strategy-02&orientation=landscape',
    rating: 4.5,
    players: '680万',
    tags: ['策略', '建造', '经典'],
    featured: false,
  },
  {
    id: 'g7',
    name: '战地风云录',
    slug: 'zhandi-fengyun',
    category: 'shooting',
    description: '现代战争题材战术射击游戏，真实弹道模拟与团队协作模式，体验战场指挥官的魅力。',
    image: 'https://readdy.ai/api/search-image?query=Modern%20military%20tactical%20shooter%20game%20with%20soldiers%20in%20urban%20combat%20environment%2C%20realistic%20gear%2C%20dusty%20atmosphere%2C%20cinematic%20war%20photography%20style%2C%20dramatic%20lighting%2C%20warm%20desert%20tones&width=600&height=400&seq=game-shooting-02&orientation=landscape',
    rating: 4.4,
    players: '540万',
    tags: ['射击', '战术', '团队'],
    featured: false,
  },
  {
    id: 'g8',
    name: '跑跑卡丁车OL',
    slug: 'paopao-kart',
    category: 'casual',
    description: '经典休闲竞速游戏网页版，可爱角色与趣味道具赛，与好友一起享受极速漂移的快乐。',
    image: 'https://readdy.ai/api/search-image?query=Cute%20cartoon%20kart%20racing%20game%20with%20colorful%20go-karts%20drifting%20on%20a%20bright%20fantasy%20race%20track%20with%20cheerful%20characters%2C%20vibrant%20colors%2C%20fun%20atmosphere%2C%20animated%20style&width=600&height=400&seq=game-casual-02&orientation=landscape',
    rating: 4.8,
    players: '1890万',
    tags: ['竞速', '休闲', '多人'],
    featured: true,
  },
  {
    id: 'g9',
    name: '暗黑破坏城',
    slug: 'anhei-pohuai',
    category: 'role-playing',
    description: '暗黑风格动作RPG，丰富的装备系统与技能树，挑战无尽地下城与强大Boss。',
    image: 'https://readdy.ai/api/search-image?query=Dark%20fantasy%20dungeon%20crawler%20game%20with%20a%20warrior%20fighting%20monsters%20in%20a%20gloomy%20cathedral%20ruin%2C%20mysterious%20atmosphere%2C%20torch%20lighting%2C%20gothic%20art%20style%2C%20dramatic%20shadows&width=600&height=400&seq=game-rpg-03&orientation=landscape',
    rating: 4.6,
    players: '630万',
    tags: ['暗黑', '动作', '刷装备'],
    featured: false,
  },
  {
    id: 'g10',
    name: '足球经理人',
    slug: 'zuqiu-jingli',
    category: 'casual',
    description: '体育经营模拟游戏，组建你的梦幻球队、制定战术策略，带领球队走向冠军之路。',
    image: 'https://readdy.ai/api/search-image?query=Soccer%20management%20simulation%20game%20with%20a%20stadium%20full%20of%20cheering%20fans%20and%20players%20on%20the%20field%2C%20strategic%20overview%2C%20green%20pitch%2C%20bright%20stadium%20lights%2C%20sports%20illustration%20style&width=600&height=400&seq=game-sports-01&orientation=landscape',
    rating: 4.3,
    players: '420万',
    tags: ['体育', '经营', '模拟'],
    featured: false,
  },
  {
    id: 'g11',
    name: '塔防三国志',
    slug: 'tafang-sanguo',
    category: 'strategy',
    description: '三国题材创新塔防游戏，招募三国名将布阵防守，策略搭配千变万化，趣味无穷。',
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20tower%20defense%20game%20with%20Three%20Kingdoms%20generals%20guarding%20castle%20walls%20against%20invading%20armies%2C%20strategic%20placement%2C%20warm%20autumn%20colors%2C%20detailed%20Chinese%20art%20style&width=600&height=400&seq=game-tower-01&orientation=landscape',
    rating: 4.5,
    players: '580万',
    tags: ['塔防', '三国', '策略'],
    featured: false,
  },
  {
    id: 'g12',
    name: '枪神对决',
    slug: 'qiangshen-duijue',
    category: 'shooting',
    description: '快节奏竞技射击游戏，多种模式任你选择，精准枪法与团队配合的巅峰对决。',
    image: 'https://readdy.ai/api/search-image?query=Competitive%20arena%20shooter%20game%20with%20two%20players%20facing%20off%20in%20a%20futuristic%20urban%20battlefield%2C%20fast%20paced%20action%2C%20neon%20accents%2C%20dynamic%20composition%2C%20esports%20style%20illustration&width=600&height=400&seq=game-shooting-03&orientation=landscape',
    rating: 4.4,
    players: '490万',
    tags: ['竞技', '射击', '快节奏'],
    featured: false,
  },
];

export const categories = [
  {
    id: 'role-playing',
    name: '角色扮演',
    slug: 'role-playing',
    icon: 'ri-user-star-line',
    description: '沉浸式剧情体验，打造属于你的角色传奇',
    count: 156,
  },
  {
    id: 'strategy',
    name: '策略塔防',
    slug: 'strategy',
    icon: 'ri-mind-map',
    description: '运筹帷幄，智谋定乾坤',
    count: 128,
  },
  {
    id: 'shooting',
    name: '射击竞技',
    slug: 'shooting',
    icon: 'ri-crosshair-line',
    description: '枪林弹雨，感受竞技快感',
    count: 94,
  },
  {
    id: 'casual',
    name: '休闲益智',
    slug: 'casual',
    icon: 'ri-gamepad-line',
    description: '轻松一刻，随时随地畅玩',
    count: 203,
  },
  {
    id: 'sports',
    name: '体育竞速',
    slug: 'sports',
    icon: 'ri-speed-up-line',
    description: '速度与激情，体验赛场荣耀',
    count: 67,
  },
  {
    id: 'card',
    name: '卡牌桌游',
    slug: 'card',
    icon: 'ri-stack-line',
    description: '策略卡牌，智慧博弈对决',
    count: 89,
  },
];

export type GameCategory = typeof categories[number];